// extracted by mini-css-extract-plugin
export default {"iconInfo":"TreatmentPurpose_iconInfo__a+OVD","treatmentPathButton":"TreatmentPurpose_treatmentPathButton__AkdVW"};